import { auth } from '../../../firebase/config'

export function addFreeItem(itemId, navigation) {
	navigation.navigate('Item', {
		token: itemId,
		editing: null,
		isOpen: true,
		menuId: global.menuId,
		menuItemCategory: 'Free Item',
		freeItem: true,
		bogo: false,
	})
}

// redeemedList is Customers.redeemedPromos.
export function userCanRedeem(couponData, redeemedList) {
	// If no data provided, user can redeem
	if (!couponData || !redeemedList) return true

	// If qty is -1, it means unlimited redemptions
	const qty = couponData.redemptionQty
	if (qty === -1) return true
	if (!auth.currentUser) return false

	// Count how many times this coupon was redeemed
	const occurrences = redeemedList.reduce((acc, curr) => acc + (curr === couponData.id ? 1 : 0), 0)
	return occurrences < qty
}

export function restaurantIsPresent(couponData, cartItems) {
	if (!couponData || !Object.prototype.hasOwnProperty.call(couponData, 'restaurantIds')) {
		return true
	}

	const { restaurantIds } = couponData

	// if restaurantIds is undefined or an empty array, return true
	if (!restaurantIds || restaurantIds.length === 0) {
		return true
	}

	return cartItems.some((item: any) => restaurantIds.includes(item.rId))
}

export function restaurantDiscount(couponData, cartItems) {
	if (couponData && couponData.restaurantIds && couponData.rate) {
		const { restaurantIds, rate } = couponData
		const { type, amount } = rate
		const applicableItems = cartItems.filter(item => restaurantIds.includes(item.rId))
		const totalApplicable =
			applicableItems.reduce((acc, curr) => acc + curr.total * curr.qty, 0) ?? 0

		if (type === 'fixed') {
			return {
				amount: totalApplicable < amount * 100 ? totalApplicable : amount * 100,
				total: totalApplicable / 100,
			}
		} else if (type === 'percent') {
			const total = cartItems.reduce((acc, curr) => acc + curr.total * curr.qty, 0) ?? 0
			const applicableDiscount = totalApplicable * amount
			return {
				amount: (applicableDiscount / total) * 100,
				total: totalApplicable / 100,
			}
		} else {
			return null
		}
	} else {
		return null
	}
}

export function restaurantDiscountPercentages(couponData, cartItems) {
	if (!couponData || !couponData.rate) {
		return null
	}

	const restaurantIds = couponData.restaurantIds || cartItems.map(item => item.rId)
	const { type, amount } = couponData.rate
	const maxDiscount = couponData['maxDiscount'] * 100

	// Initialize all rIds in the cart with a discount amount of 0
	const discountAmounts = cartItems.reduce((acc, curr) => {
		acc[curr.rId] = 0
		return acc
	}, {})

	const applicableItems = cartItems.filter(item => restaurantIds.includes(item.rId))
	const orderTotal = applicableItems.reduce((sum, item) => sum + item.qty * item.total, 0)

	if (orderTotal === 0) {
		return discountAmounts
	}

	// Calculate unrounded discounts first
	const unroundedDiscounts = {}
	const restaurantTotals = {}
	let totalUnroundedDiscount = 0

	applicableItems.forEach(item => {
		const itemTotal = item.total * item.qty
		let itemDiscount

		if (type === 'fixed') {
			itemDiscount = (itemTotal / orderTotal) * (amount * 100)
		} else if (type === 'percent') {
			itemDiscount = itemTotal * (amount / 100)
		}

		unroundedDiscounts[item.rId] = (unroundedDiscounts[item.rId] || 0) + itemDiscount
		restaurantTotals[item.rId] = (restaurantTotals[item.rId] || 0) + itemTotal
		totalUnroundedDiscount += itemDiscount
	})

	if (maxDiscount && totalUnroundedDiscount > maxDiscount) {
		const scalingFactor = maxDiscount / totalUnroundedDiscount

		Object.keys(unroundedDiscounts).forEach(rId => {
			unroundedDiscounts[rId] *= scalingFactor
		})

		totalUnroundedDiscount = maxDiscount
	}

	// Round discount amounts for each restaurant
	Object.keys(unroundedDiscounts).forEach(rId => {
		discountAmounts[rId] = Math.round(unroundedDiscounts[rId])
	})

	// Calculate the total rounded discount
	const totalRoundedDiscount: any = Object.values(discountAmounts).reduce(
		(sum: number, val: number) => sum + val,
		0
	)

	// Handle rounding discrepancy
	const discrepancy = Math.round(totalUnroundedDiscount) - totalRoundedDiscount

	if (discrepancy !== 0) {
		// Get restaurants with non-zero discounts
		const activeRestaurants = Object.keys(discountAmounts).filter(rId => discountAmounts[rId] > 0)

		if (activeRestaurants.length > 0) {
			// Distribute the discrepancy evenly among restaurants with non-zero discounts
			const adjustment = discrepancy > 0 ? 1 : -1
			let remainingAdjustment = Math.abs(discrepancy)

			// Sort restaurants by discount amount to adjust larger discounts first
			activeRestaurants.sort((a, b) => discountAmounts[b] - discountAmounts[a])

			let index = 0
			while (remainingAdjustment > 0) {
				discountAmounts[activeRestaurants[index]] += adjustment
				remainingAdjustment--
				index = (index + 1) % activeRestaurants.length
			}
		}
	}
	Object.keys(discountAmounts).forEach(rId => {
		const cappedDiscount = Math.min(discountAmounts[rId] ?? 0, restaurantTotals[rId] ?? 0)
		discountAmounts[rId] = cappedDiscount ?? 0
	})
	return discountAmounts
}

export function codeIsAvailable(couponData, availableList) {
	var isAvailable = true
	if (couponData && couponData.customerSpecific) {
		if (availableList.indexOf(couponData['id']) == -1) {
			isAvailable = false
		}
	}
	return isAvailable
}

//codes that are not available based on other redeemed codes
//i.e. having 2 promo codes (storefront & online) but only letting 1 be redeemed
//return true if code is valid
//return false if invalid
export function sameCodeGroupNotRedeemed(couponData, redeemedList) {
	var isNotExcluded = true
	if (couponData && redeemedList && couponData.includeIds) {
		var toExclude = couponData.includeIds
		toExclude.forEach(id => {
			if (redeemedList.indexOf(id) !== -1) {
				isNotExcluded = false
			}
		})
	}
	return isNotExcluded
}
